import { QuestionBase } from "./question-base";

export class DateQuestion extends QuestionBase<string> {
  controlType = "date";
}
